import React, { Component } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withStyles } from 'material-ui/styles'
import { Button, TextField, Typography, CircularProgress } from 'material-ui'
import { Email, Person, VpnKey } from 'material-ui-icons'
import isEmail from 'validator/lib/isEmail'
import { SIGNUP_USER } from '@/graphql/mutations/user'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import ChevronLeftIcon from 'material-ui-icons/ChevronLeft'
import {
  GC_USER_ID,
  GC_AUTH_TOKEN,
  ALABASTER,
  BOULDER,
  KOROMIKO
} from '@/constants'

import { READ_USERNAME } from '@/graphql/queries/user'

const styles = theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  rootInner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    borderStyle: 'solid',
    borderColor: BOULDER,
    borderWidth: 0,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  leftGrid: {
    backgroundColor: ALABASTER,
    width: '80%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '10%'
  },
  rightGrid: {
    backgroundImage: 'url(notebook.png)',
    backgroundSize: 'cover',
    height: '100%',
    flexGrow: 1
  },
  leftSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingLeft: 30,
    paddingRight: 30,
    marginBottom: 15
  },
  errorContainer: {
    fontSize: 12,
    color: KOROMIKO,
    marginBottom: 30
  },
  btnContainer: {
    textAlign: 'center',
    paddingLeft: 30,
    paddingRight: 30
  },
  txtContainer: {
    textAlign: 'center',
    paddingLeft: 60,
    paddingRight: 60,
    paddingTop: 20
  },
  text: {
    fontSize: 14,
    color: 'grey'
  },
  button: {
    width: '65%',
    backgroundColor: 'rgba(80, 227, 194, .7)',
    color: 'white',
    fontSize: 15
  },
  icon: {
    width: 40,
    marginRight: 10,
    color: 'lightgrey'
  },
  textField: {
    backgroundColor: 'white',
    flexGrow: 1
  },
  txtContainerLoggedinAs: {
    position: 'relative',
    textAlign: 'center',
    paddingLeft: 60,
    paddingRight: 60,
    top: -100
  },
  btnContainerLoggedinAs: {
    position: 'relative',
    textAlign: 'right',
    paddingLeft: 60,
    paddingRight: 5
  },
  backBtn: {
    position: 'absolute',
    textAlign: 'left',
    left: 8,
    top: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
    color: 'lightgrey'
  }
})

@withRouter
@withStyles(styles)
@graphql(SIGNUP_USER, { name: 'signupUser' })
@graphql(READ_USERNAME, {
  name: 'ReadUserName',
  options: ({ match }) => ({
    variables: {
      userID: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
export default class Register extends Component {
  state = {
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
    errors: [],
    loader: false
  }

  updateField = evt => {
    this.setState({ loader: false })
    const { name, value } = evt.currentTarget
    this.setState({ [name]: value })
  }

  addError = msg => {
    this.setState(prevState => ({
      errors: [...prevState.errors, msg]
    }))
  }

  isValid = () => {
    const { email, name, password, confirmPassword } = this.state

    if (!isEmail(email)) {
      this.setState({ loader: false })
      this.addError('Invalid email address.')
      return false
    }

    if (password.length < 8) {
      this.setState({ loader: false })
      this.addError('Minimum password length: 8 characters')
      return false
    }

    if (
      !email.length ||
      !name.length ||
      !password.length ||
      !confirmPassword.length
    ) {
      this.setState({ loader: false })
      this.addError('All fields are required.')
      return false
    }

    if (password !== confirmPassword) {
      this.setState({ loader: false })
      this.addError("Passwords doesn't match.")
      return false
    }

    return true
  }

  register = evt => {
    this.setState({ loader: true })
    evt.preventDefault()
    this.setState({ errors: [] }, async () => {
      if (this.isValid()) {
        const { email, name, password } = this.state
        try {
          const result = await this.props.signupUser({
            variables: {
              email,
              password,
              name
            }
          })
          const { id, token } = result.data.signupUser
          // todo - decouple/use cookies
          global.localStorage.setItem(GC_USER_ID, id)
          global.localStorage.setItem(GC_AUTH_TOKEN, token)
          // to add select list
          // redirect to homepage
          this.props.history.push(`/start`)
        } catch (e) {
          this.setState({ loader: false })
          console.log(e)
          this.addError(
            e.toString().includes('Email already in use')
              ? 'Email already in use'
              : e.toString().includes('Not a valid email')
                ? 'Not a valid email'
                : 'Sign up failed, please try again!'
          )
        }
      }
    })
  }

  handleClose = () => {
    this.props.history.push(`/start`)
  }

  handleCloseBack = () => {
    this.props.history.push(`/start`)
  }

  render() {
    const { classes } = this.props
    const { errors } = this.state
    const userId = global.localStorage.getItem(GC_USER_ID)

    // get user name
    if (userId) {
      if (this.props.ReadUserName && this.props.ReadUserName.loading) {
        return <div>Loading</div>
      }

      if (this.props.ReadUserName && this.props.ReadUserName.error) {
        return <div>Error: {this.props.ReadUserName.error}</div>
      }
    }

    return (
      <div className={classes.root}>
        <div className={classes.rootInner}>
          <div className={classes.leftGrid}>
            <div className={classes.leftSubContainer}>
              <div
                style={{
                  width: '100%',
                  position: 'absolute',
                  left: 0,
                  top: 100
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + '/alchemy_title.png'}
                  alt="title"
                />
              </div>
              {userId ? (
                <div>
                  <div className={classes.txtContainerLoggedinAs}>
                    <Typography className={classes.text} variant="body1">
                      You are logged in as {this.props.ReadUserName.User.name}.<br />{' '}
                      <Link to={`/start`} onClick={this.signOut}>
                        Log Out?
                      </Link>
                    </Typography>
                  </div>
                  <div className={classes.btnContainerLoggedinAs}>
                    <Button color="inherit" onClick={this.handleClose}>
                      <Typography
                        variant="body1"
                        style={{ fontSize: 18, color: 'grey' }}
                      >
                        Continue
                      </Typography>
                      <ChevronRightIcon style={{ color: 'grey' }} />
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  {errors && (
                    <div className={classes.errorContainer}>
                      {errors.map((error, key) => <div key={key}>{error}</div>)}
                    </div>
                  )}
                  <div className={classes.inputContainer}>
                    <Email className={classes.icon} />
                    <TextField
                      className={classes.textField}
                      label="Email"
                      name="email"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.inputContainer}>
                    <Person className={classes.icon} />
                    <TextField
                      className={classes.textField}
                      label="Name"
                      name="name"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.inputContainer}>
                    <VpnKey className={classes.icon} />
                    <TextField
                      type="password"
                      className={classes.textField}
                      label="Password"
                      name="password"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.inputContainer}>
                    <VpnKey className={classes.icon} />
                    <TextField
                      type="password"
                      className={classes.textField}
                      label="Confirm Password"
                      name="confirmPassword"
                      onChange={this.updateField}
                    />
                  </div>
                  <div className={classes.btnContainer}>
                    {this.state.loader ? (
                      <div>
                        <CircularProgress
                          className={classes.progress}
                          size={40}
                        />
                      </div>
                    ) : (
                      <Button
                        className={classes.button}
                        onClick={this.register}
                      >
                        Sign Up
                      </Button>
                    )}
                  </div>
                  <div className={classes.txtContainer}>
                    <Typography variant="body1">
                      Already a member? <Link to={`/login`}>Login</Link>
                    </Typography>
                  </div>
                  <div className={classes.txtContainer}>
                    <Typography variant="body1">
                      By continuing, you agree to our{' '}
                      <Link to={`/register`}>Privacy Policy</Link>
                    </Typography>
                  </div>

                  <div className={classes.backBtn}>
                    <Button color="inherit" onClick={this.handleCloseBack}>
                      <ChevronLeftIcon style={{ color: 'grey' }} />
                      <Typography
                        variant="body1"
                        style={{ fontSize: 15, color: 'grey' }}
                      >
                        Back
                      </Typography>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/register/index.js